import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessObjectEntity } from './process-object.entity';

@Entity('process_type')
export class ProcessTypeEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@OneToMany(
		() => ProcessObjectEntity,
		(processObject) => processObject.fkProcessType,
		{},
	)
	public processObjects!: Array<ProcessObjectEntity>;
}
